import React from 'react'
import Navbar from './Navbar';
import Mobile_navbar from '../Component/Mobile_navbar';
import Navbar_mobile from '../Component/Navbar_mobile'

function Main_Navbar() {
  return (
    <div>
      {/* <div className='d-md-none d-md-block'><Mobile_navbar/></div> */}
      {/* <div className='d-none d-xl-block'><Navbar/></div> */}
      <div><Navbar_mobile/></div>
    </div>
  )
}

export default Main_Navbar
